import React, { InputHTMLAttributes } from 'react'

interface AdminInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  label?: string
  required?: boolean
  className?: string
  labelClassName?: string
  wrapperClassName?: string
}

const AdminInput: React.FC<AdminInputProps> = ({
  label,
  required,
  className = '',
  labelClassName = '',
  wrapperClassName = '',
  ...props
}) => {
  const baseInputClassName = `
    w-full
    py-10px
    px-12px
    border
    border-brandPrimary-20%
    rounded-8px
    text-style-body2
    text-textColorText2
    bg-transparent
    focus:outline-none
    focus:border-brandPrimary
    placeholder:text-textColorText2
  `

  const defaultLabelClassName = 'text-style-labelS text-textColorText2 mb-4px block'

  return (
    <div className={`overflow-visible ${wrapperClassName}`}>
      {label && (
        <label className={`${defaultLabelClassName} ${labelClassName}`}>
          {label}
          {required && ' *'}
        </label>
      )}
      <input
        {...props}
        className={`${baseInputClassName} ${className}`}
      />
    </div>
  )
}

export default AdminInput
